import { SchemaField } from '../../../../generic/serialization/schema-field';
import { CommunicationTaskSchema } from '../../generic/communication-task/communication-task-schema';

export class CommunicationTaskCallbackRequestSchema extends CommunicationTaskSchema {
  public static readonly serviceableAddressId = 'serviceableAddressId';

  public static readonly asyncServiceRequestId = 'asyncServiceRequestId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly orgId = undefined;

    public static readonly sessionId = undefined;

    public static readonly serviceableAddressId = undefined;

    public static readonly asyncServiceRequestId = undefined;

    public static readonly taskQueueAttributes = new Map();
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationTaskCallbackRequestSchema.serviceableAddressId] = SchemaField.autoGeneratedDocId(
      CommunicationTaskCallbackRequestSchema.Defaults.serviceableAddressId,
    );
    parameters[CommunicationTaskCallbackRequestSchema.asyncServiceRequestId] = SchemaField.autoGeneratedDocId(
      CommunicationTaskCallbackRequestSchema.Defaults.asyncServiceRequestId,
    );
    /* eslint-enable */

    return parameters;
  }
}
